module.exports = __webpack_public_path__ + "images/fcacapitalaf78cfae9bf17b130c1c12e01724c192.png";